import { React, useState, useEffect } from 'react';
import '../style/main.css';
import Music from './Music';
import { useNavigate } from 'react-router-dom';

const MusicPage = () => {
  const [active, setActive] = useState(2); // Set to 2 since this is the Music page
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('tringAuthToken');
    if (!token) {
      navigate('/');
    }
  }, []);

  const handleActive = index => {
    localStorage.setItem('mainInd', Number(index));
    setActive(index);
    if (index === 1) {
      navigate('/main'); // Navigate to main page when home is clicked
    }
  };

  return (
    <div
      className="main-container d-flex flex-column"
      style={{ position: 'relative', height: '100dvh' }}
    >
      {/* Header */}
      <div
        className="navbar-container flex-row justify-content-between align-items-center px-2 py-3"
        style={{
          position: 'sticky',
          top: 0,
          height: '8.5dvh',
        }}
      >
        {/* Your header content */}
        Header
      </div>

      {/* Music Component */}
      <div className="w-100">
        <Music />
      </div>

      {/* Navigation Footer */}
      <div
        style={{ height: '7dvh' }}
        className="d-flex flex-row justify-content-between align-items-center w-100 px-2 py-1"
      >
        <button
          style={{ border: 'none', backgroundColor: 'white', height: '6dvh' }}
          className="d-flex flex-column align-items-center"
          onClick={() => handleActive(1)}
        >
          <img
            src={active === 1 ? '/images/nav1r.svg' : '/images/nav1.svg'}
            alt="logo"
            className="mb-1"
          />
          <span
            style={{ color: active === 1 ? '#DB0F11' : 'black' }}
            className="common-txt"
          >
            Home
          </span>
        </button>

        <button
          style={{ border: 'none', backgroundColor: 'white', height: '6dvh' }}
          className="d-flex flex-column align-items-center"
          onClick={() => handleActive(2)}
        >
          <img
            src={active === 2 ? '/images/nav2r.svg' : '/images/nav2.svg'}
            alt="logo"
            className="mb-1"
          />
          <span
            style={{ color: active === 2 ? '#DB0F11' : 'black' }}
            className="common-txt"
          >
            Music
          </span>
        </button>
        <button
          style={{ border: 'none', backgroundColor: 'white', height: '6dvh' }}
          className="d-flex flex-column align-items-center"
          onClick={() => handleActive(4)}
        >
          <img
            src={active === 4 ? '/images/nav4r.svg' : '/images/nav4.svg'}
            alt="logo"
            className="mb-1"
          />
          <span
            style={{ color: active === 4 ? '#DB0F11' : 'black' }}
            className="common-txt"
          >
            Rewards
          </span>
        </button>

        <button
          onClick={() => handleActive(5)}
          style={{ border: 'none', backgroundColor: 'white', height: '6dvh' }}
          className="d-flex flex-column align-items-center"
        >
          <img
            src={active === 5 ? '/images/nav5r.svg' : '/images/nav5.svg'}
            alt="logo"
            className="mb-1"
          />
          <span
            style={{ color: active === 5 ? '#DB0F11' : 'black' }}
            className="common-txt"
          >
            Profile
          </span>
        </button>
      </div>
    </div>
  );
};

export default MusicPage;
